// @flow
import { type ActionType } from 'redux-actions';
import { requestSearchResults, receiveSearchResults } from './searchActions';
import { call, select, takeLatest, put } from 'redux-saga/effects';
import { selectToken } from 'ducks/SagaUtils';
import { addItemsTask } from 'ducks/coreDataSaga';
import { normalizeSearchResponse } from './normalizeSearchResponse';

function* fetchResults(action: ActionType<typeof requestSearchResults>) {
  const { query, method } = action.payload;
  const token = yield select(selectToken);

  try {
    const response = yield call(method, token, query);
    const responseFormatted = normalizeSearchResponse(response);

    const itemsToPut = yield call(addItemsTask, {
      data: { items: responseFormatted },
    });

    const totalPages =
      response.total_pages != null ? response.total_pages : undefined;
    yield put.resolve(receiveSearchResults(itemsToPut.items, totalPages));
  } catch (err) {
    console.error(err);
    yield put(receiveSearchResults(err));
  }
}

export default function*(): Generator<*, *, *> {
  yield takeLatest(requestSearchResults, fetchResults);
}



// WEBPACK FOOTER //
// ./src/containers/search/searchSaga.js